import { useSelector } from 'react-redux';
import {
    filterBySearch,
    filterByTargetGroup,
    filterByExperience,
    filterByTheme,
    filterByStartMonth,
    filterBySchoolType,
    sortTrainings,
} from 'utilities/trainingFilters';

/**
 * Custom hook to fetch and filter trainings based on various criteria
 * @param {Object} params - Hook parameters
 * @param {string} params.searchValue - Search string
 * @param {Array} params.targetGroupSelected - Selected target groups
 * @param {Array} params.experienceSelected - Selected experience levels
 * @param {Array} params.themeSelected - Selected themes
 * @param {Array} params.startMonthSelected - Selected start months
 * @param {boolean} params.isSchoolsTrainingPage - Whether viewing school-specific trainings
 * @param {Object} params.school - School object
 * @param {Object} params.schoolGroup - School group object
 * @returns {Array} Filtered and sorted trainings
 */
export default function useTrainings({
    searchValue,
    targetGroupSelected,
    experienceSelected,
    themeSelected,
    startMonthSelected,
    isSchoolsTrainingPage,
    school,
    schoolGroup,
}) {
    const trainings = useSelector((state) =>
        state?.training?.entities?.allIds
            ?.map((id) => state?.training?.entities?.byId[id])
            .filter((training) => !training.is_network_event)
    );

    if (!trainings) return [];

    // Apply all filters in sequence
    let filteredTrainings = filterBySchoolType(
        trainings,
        isSchoolsTrainingPage,
        school,
        schoolGroup
    );

    filteredTrainings = filterBySearch(filteredTrainings, searchValue);
    filteredTrainings = filterByTargetGroup(
        filteredTrainings,
        targetGroupSelected
    );
    filteredTrainings = filterByExperience(
        filteredTrainings,
        experienceSelected
    );
    filteredTrainings = filterByTheme(filteredTrainings, themeSelected);
    filteredTrainings = filterByStartMonth(
        filteredTrainings,
        startMonthSelected
    );

    // Sort the final result
    return sortTrainings(filteredTrainings);
}
